import { render, staticRenderFns } from "./FooterCard.vue?vue&type=template&id=074348ce&scoped=true&"
import script from "./FooterCard.vue?vue&type=script&lang=js&"
export * from "./FooterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074348ce",
  null
  
)

export default component.exports